import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { ReactComponent as ChevronRightIcon } from "../../../assets/images/btn-right-aero.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const LicenseTypeModal = ({
  show,
  onHide,
  value,
  onSave,
  shouldUpdateProfile = false,
  isApplyPage = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedLicense, setSelectedLicense] = useState("");

  const licenseOptions = [
    { value: "RN", label: "Registered Nurse (RN)" },
    { value: "LPN", label: "Licensed Practical Nurse (LPN)" },
    { value: "NP", label: "Nurse Practitioner (NP)" },
    { value: "CRNA", label: "Certified Registered Nurse Anesthetist (CRNA)" },
    { value: "CNM", label: "Certified Nurse Midwife (CNM)" },
  ];

  // Load existing value from API
  // useEffect(() => {
  //   if (!show) return;

  //   const license = store?.profileItem?.data?.nurseProfile?.license_type;

  //   if (license) {
  //     setSelectedLicense(license);
  //   }
  // }, [show, store?.profileItem]);
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      // ✅ Apply page → use passed value
      setSelectedLicense(value || "");
    } else {
      // ✅ Profile page → use API value
      const license = store?.profileItem?.data?.nurseProfile?.license_type;

      if (license) {
        setSelectedLicense(license);
      }
    }
  }, [show, value, store?.profileItem]);
  const handleSave = () => {
    if (!selectedLicense) return;

    if (isApplyPage) {
      // ✅ ALWAYS update local form
      onSave(selectedLicense);

      // 🔥 ONLY call API if empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append("name", store?.profileItem?.data?.full_name || "");

        formData.append("license_type", selectedLicense);

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append("name", store?.profileItem?.data?.full_name || "");

      formData.append("license_type", selectedLicense);

      dispatch(updateProfile(formData));
    }
  };

  // const handleSave = () => {
  //   if (!selectedLicense) return;

  //   if (isApplyPage) {
  //     // ✅ Apply Job Page → local update
  //     onSave(selectedLicense);
  //     onHide();
  //   } else {
  //     // ✅ Profile Page → API call
  //     const formData = new FormData();
  //     formData.append("name", store?.profileItem?.data?.full_name || "");
  //     formData.append("license_type", selectedLicense);

  //     dispatch(updateProfile(formData));
  //   }
  // };
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      dispatch(getViewProfile());
      onHide();
    }
  }, [store?.actionFlag]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Select Your License Type</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {licenseOptions.map((option) => (
              <div
                key={option.value}
                className={`radio-option col-lg-6 ${
                  selectedLicense === option.value ? "selected" : ""
                }`}
                onClick={() => setSelectedLicense(option.value)}
              >
                <div className="contentwrap">
                  <input
                    type="radio"
                    checked={selectedLicense === option.value}
                    readOnly
                  />

                  <label className="radio-label">{option.label}</label>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="buttons text-center mt-4">
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={store?.isLoading || !selectedLicense}
          >
            {store?.isLoading ? "Saving..." : "Save"}{" "}
            <ChevronRightIcon className="button-icon" />
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LicenseTypeModal;
